var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProofOfAddressCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4157 6.41176L15.5865 3.58258C15.2114 3.20733 14.7025 2.99634 14.1719 2.99634H6.99693C5.8919 2.99634 4.99609 3.89214 4.99609 4.99717V19.003C4.99609 20.108 5.8919 21.0038 6.99693 21.0038H17.0011C18.1061 21.0038 19.0019 20.108 19.0019 19.003V7.82635C19.0019 7.29574 18.7909 6.7869 18.4157 6.41176Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 11.5L11.4987 14.001L9.99805 12.5004",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProofOfAddressCheck);
export default __webpack_public_path__ + "static/media/proof_of_address_check.c97e491f8c59cc22c8e8efd609fbfef8.svg";
export { ForwardRef as ReactComponent };